<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="feeSetting ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">
                <div class="row">
                    <div class="  col-md-12">
                        <div class="bc d-flex align-items-center pl-3">
                            <img alt="Logo" src="../../assets/img/fees.png" class="mh-45px pb-2">
                            <div *ngIf="submitButton" class="mb-0">

                                <span class="main-content-label"><b>Fee Mode </b></span><br>
                                <span class="text-muted card-sub-title mb-0">Fee Mode</span>
                            </div>
                            <div *ngIf="editButton" class="mb-0">
                                <span class="main-content-label"><b>Fee Mode </b></span><br>
                                <span class="text-muted card-sub-title mb-0">Fee Mode</span>

                            </div>
                            <div *ngIf="deleteButton" class="mb-0">
                                <span class="main-content-label"><b>Fee Mode </b></span><br>
                                <span class="text-muted card-sub-title mb-0">Fee Mode</span>
                            </div>
                        </div>
                    </div>
                    <hr class="mt-3">
                    <div class="row mt-1 clearfix">

                        <div class="col-sm-6">

                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>Session</mat-label>
                                <mat-select #select232 placeholder="Session" class="colorblack" required
                                    formControlName="Session">
                                    <mat-select-filter *ngIf="select232.focused" [placeholder]="'Filter'"
                                        [displayMember]="'SnName'" [array]="sessionList"
                                        (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of SessionFilterList"
                                        (click)="getCollegeData(item.SnNo)" [value]="item.SnNo">
                                        {{item.SnName}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="feeSetting.controls['Session'].touched && feeSetting.controls['Session'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>
                        <div class="col-sm-6">

                            <!-- <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>College</mat-label>
                                <mat-select multiple #select23 placeholder="" class="colorblack" required
                                    formControlName="College">
                                    <mat-select-filter *ngIf="select23.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CgName'" [array]="collegedataList"
                                        (filteredReturn)="collegedataFilterList =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of collegedataFilterList" [value]="item.CgCode">
                                        {{item.CgCode}}-{{item.CgName}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="feeSetting.controls['College'].touched && feeSetting.controls['College'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field> -->

                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>College</mat-label>
                                <mat-select multiple #select23 placeholder="" class="colorblack" required
                                  formControlName="College" (selectionChange)="onSelectionChange($event)">
                                  <mat-select-filter *ngIf="select23.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CgName'" [array]="collegedataList"
                                    (filteredReturn)="onFilteredReturn($event)"></mat-select-filter>
                                  <mat-option *ngFor="let item of collegedataFilterList" [value]="item.CgCode">
                                    {{ item.CgCode }}-{{ item.CgName }}
                                  </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp" *ngIf="feeSetting.controls['College'].touched && feeSetting.controls['College'].errors?.required">
                                  Mandatory
                                </mat-error>
                              </mat-form-field>

                        </div>
                        <div class="col-sm-6">

                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>
                                    Fee Mode
                                </mat-label>
                                <mat-select #select35 required class="colorblack" formControlName="FeeMode">
                                    <mat-select-filter *ngIf="select35.focused" [placeholder]="'Filter'"
                                        [displayMember]="'CdDesc'" [array]="feeModeList"
                                        (filteredReturn)="filteredfeeModeList =$event"></mat-select-filter>
                                    <mat-option *ngFor="let item of filteredfeeModeList" [value]="item.CdCode">
                                        {{item.CdDesc}}
                                    </mat-option>
                                </mat-select>
                                <mat-error class="margin_tp"
                                    *ngIf="feeSetting.controls['FeeMode'].touched && feeSetting.controls['FeeMode'].errors?.required">
                                    Mandatory
                                </mat-error>
                            </mat-form-field>

                        </div>

                    </div>
                    <div class="row prpl">
                        <div class="col-sm-12">
                            <button type="button" *ngIf="submitButton && feeSettingCreate"
                                class="btn btn-primary btn-icon-text floatright fr sz mt-1" (click)="save()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                    Save
                                </span>
                            </button>
                            <button type="button" *ngIf="editButton && feeSettingUpdate"
                                class="btn btn-primary btn-icon-text floatright fr sz mt-1" (click)="update()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                                    Update
                                </span>
                            </button>
                            <button type="button" *ngIf="deleteButton && feeSettingDelete"
                                class="btn btn-primary btn-icon-text floatright fr sz mt-1" (click)="DeletetheRecord()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                                    Delete
                                </span>
                            </button>
                            <button type="button" [mat-dialog-close]="true"
                                class="btn btn-primary btn-icon-text floatright fr sz mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 5px;">
                                    Back
                                </span>
                            </button>
                        </div>

                    </div>
                </div>
            </div>
            <!-- </div> -->
        </div>
    </form>
</div>